import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, SectionHeading, Reveal, Overline } from "../components/Kinetic";
import { SubmissionForm } from "../components/SubmissionForm";

const ScientifiquesPage = () => {
  const { t } = useLanguage();
  useSEO(t("scientifiques.metaTitle"), t("scientifiques.metaDesc"));
  const profiles = t("scientifiques.profiles");

  const fields = [
    { name: "name", label: t("forms.name"), type: "text" },
    { name: "email", label: t("forms.email"), type: "email" },
    { name: "organization", label: t("forms.organization"), type: "text", required: false },
    { name: "fonction", label: t("forms.fonction"), type: "text", required: false },
    { name: "profile", label: t("forms.profile"), type: "select", options: t("forms.profileOptions") },
    { name: "domain", label: t("forms.domain"), type: "text" },
    { name: "pays", label: t("forms.pays"), type: "text" },
    { name: "site", label: t("forms.site"), type: "text", required: false },
    { name: "contribution", label: t("forms.contribution"), type: "select", options: t("forms.contributionOptions") },
    { name: "message", label: t("forms.message"), type: "textarea" },
  ];

  return (
    <div data-testid="scientifiques-page">
      <PageHero
        overline={t("scientifiques.overline")}
        titleLines={t("scientifiques.titleLines")}
        intro={t("scientifiques.intro")}
        testid="scientifiques"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading overline={t("scientifiques.profilesOverline")} title={t("scientifiques.profilesTitle")} />
          <div className="mt-16 grid gap-px bg-graphite/10 sm:grid-cols-2 lg:grid-cols-3">
            {profiles.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.07} className="group bg-bone p-7 transition-colors duration-300 hover:bg-forest">
                <p className="font-mono text-xs text-forest transition-colors duration-300 group-hover:text-white/60">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="mt-5 font-display text-lg font-bold uppercase tracking-tight text-graphite transition-colors duration-300 group-hover:text-white">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-graphite-soft transition-colors duration-300 group-hover:text-white/70">
                  {p.text}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-forest py-20 text-white md:py-28">
        <div className="mx-auto max-w-7xl px-6">
          <Reveal>
            <h2 className="max-w-3xl font-display text-3xl md:text-4xl font-light tracking-tight leading-tight" data-testid="scientifiques-callout">
              {t("scientifiques.calloutTitle")}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-white/70">
              {t("scientifiques.calloutText")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-graphite/10 bg-white py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Reveal y={16}>
              <Overline>{t("nav.scientifiques")}</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-3xl md:text-5xl font-light tracking-tight text-graphite">
                {t("scientifiques.formTitle")}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-3">
            <SubmissionForm formType="network" fields={fields} submitLabel={t("scientifiques.formSubmit")} testid="network" />
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default ScientifiquesPage;
